import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#fff",
      "data-figma-bg-blur-radius": "8"
    }, [
      _createElementVNode("rect", {
        width: "56",
        height: "56",
        "fill-opacity": ".3",
        rx: "16"
      }),
      _createElementVNode("path", { d: "M37.25 36.5h-1.31V24.91c0-1.47-.84-2.73-2.05-3.37v-.74c0-1.55-1.26-2.8-2.81-2.8h-6.16c-1.55 0-2.81 1.25-2.81 2.8v.74c-1.21.64-2.05 1.9-2.05 3.37V36.5h-1.31a.749.749 0 1 0 0 1.5h18.5a.749.749 0 1 0 0-1.5m-11.31-5.18h-1.02c-.42 0-.75-.34-.75-.75v-1.03c0-.42.33-.75.75-.75h1.02c.42 0 .75.33.75.75v1.03c0 .41-.33.75-.75.75m-1.77-5.38v-1.03c0-.41.33-.75.75-.75h1.02c.42 0 .75.34.75.75v1.03c0 .41-.33.75-.75.75h-1.02c-.42 0-.75-.34-.75-.75m5.14 10.56h-2.62v-1.31c0-.72.59-1.31 1.31-1.31s1.31.59 1.31 1.31zm2.52-5.93c0 .41-.33.75-.75.75h-1.02c-.42 0-.75-.34-.75-.75v-1.03c0-.42.33-.75.75-.75h1.02c.42 0 .75.33.75.75zm0-4.63c0 .41-.33.75-.75.75h-1.02c-.42 0-.75-.34-.75-.75v-1.03c0-.41.33-.75.75-.75h1.02c.42 0 .75.34.75.75zm.56-4.86h-8.78v-.28c0-.72.59-1.3 1.31-1.3h6.16c.72 0 1.31.58 1.31 1.3z" })
    ], -1)
  ]))]))
}
export default { render: render }